import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Injector,
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { ToastService } from '@app/modules/toast/service/toast.service';
import { E2E_ATTRIBUTES, ToastParams, ToastType } from '@shared/types';
import { BaseComponent } from '@components/base-component';
import { toastFadeInOutAnimation } from './animations/toast.animation';
import { lazyInject } from '@shared/decorators';

/**
 *
 * Toast component.
 * @class ToastComponent
 *
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: toastFadeInOutAnimation,
  selector: 'toast-container',
  styleUrls: ['./toast.component.scss'],
  templateUrl: './toast.component.html',
  standalone: false,
})
export class ToastComponent extends BaseComponent implements OnInit {
  @lazyInject(ToastService) public toastService: ToastService;
  public toasts: ToastParams[];
  public e2eAttr: string = E2E_ATTRIBUTES.TOAST_CONTAINER;
  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;

  public constructor(protected injector: Injector) {
    super(injector);
    this.cd.detach();
  }

  public ngOnInit(): void {
    this.toastService.toasts$
      .pipe(takeUntil(this.dispose$))
      .subscribe((toasts) => {
        this.toasts = toasts;
        this.cd.detectChanges();
      });
  }

  public onClose(param: ToastParams): void {
    this.toastService.removeToast(param);
  }

  public getToastTitle(toastType: ToastType): string {
    return this.toastService.getToastTitle(toastType);
  }
}
